import { OnEvent, Service } from '@toeverything/infra';

import { WorkspaceInitialized } from '../../workspace/events';
import { WorkspaceService } from '../../workspace/services/workspace';
import { bindWorkspaceDatabasePorts } from './database-subdoc-preload';

/** Own the collection ports before any headless or interactive database source opens. */
@OnEvent(WorkspaceInitialized, service => service.onWorkspaceInitialized)
export class WorkspaceDatabasePortsService extends Service {
  private releasePorts?: () => void;

  constructor(private readonly workspaceService: WorkspaceService) {
    super();
  }

  onWorkspaceInitialized(): void {
    if (this.releasePorts) return;
    this.releasePorts = bindWorkspaceDatabasePorts(this.workspaceService);
  }

  override dispose(): void {
    this.releasePorts?.();
    this.releasePorts = undefined;
    super.dispose();
  }
}
